import type { SVGProps } from 'react';
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="m8 4.127 3.333 3v5.206H10v-4H6v4H4.667V7.127zm0-1.794-6.667 6h2v5.334h4v-4h1.334v4h4V8.333h2z" />
  </svg>
);
export default SvgHome;
